import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import { auth } from "../authentication/firebase";

export default function UserAvatar({
  onClick,
  showInfo = true,
  size = "medium",
}) {
  const navigate = useNavigate();
  const displayName = auth.currentUser?.displayName;
  const photoURL = auth.currentUser?.photoURL;
  const email = auth.currentUser?.email;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    navigate("/profile");
  };

  const getAvatarSize = () => {
    switch (size) {
      case "small":
        return { width: 30, height: 30, fontSize: "14px" };
      case "large":
        return { width: 50, height: 50, fontSize: "24px" };
      case "medium":
      default:
        return { width: 40, height: 40, fontSize: "20px" };
    }
  };

  const avatarSize = getAvatarSize();

  return (
    <StyledUserAvatar>
      <Avatar
        onClick={handleClick}
        src={photoURL}
        style={{
          fontSize: avatarSize.fontSize,
          border: "2px solid #f79c16",
          backgroundColor: "#85ce33",
        }}
        sx={{ width: avatarSize.width, height: avatarSize.height }}
      >
        {displayName?.charAt(0) || email?.charAt(0) || "W"}
      </Avatar>
      {showInfo && (
        <div className="profile-info">
          <h5>{displayName}</h5>
          <p>{email}</p>
        </div>
      )}
    </StyledUserAvatar>
  );
}

const StyledUserAvatar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .profile-info {
    h5 {
      margin: 0;
      font-size: 1rem;
      color: var(--text-color);
    }

    p {
      margin: 0;
      font-size: 0.8rem;
      color: var(--text-light-color);
    }
  }
`;
